import {ENDPOINTS} from '@/config/constants'
import api, {HTTPMethod} from '@/helpers/api'
import {
  GetTraitCategoriesRequest,
  GetTraitCategoriesRequestSchema,
  GetTraitCategoriesResponse,
  GetTraitCategoriesResponseSchema,
} from '@/types/paramFilters/traitCategories'

export const getTraitCategoriesService = (signal?: AbortSignal) => {
  return api<GetTraitCategoriesRequest, GetTraitCategoriesResponse>({
    method: HTTPMethod.GET,
    path: ENDPOINTS.LOAD_TRAIT_CATEGORIES,
    requestSchema: GetTraitCategoriesRequestSchema,
    responseSchema: GetTraitCategoriesResponseSchema,
    signal,
  })()
}
